import React from 'react'
import { Link } from 'react-router-dom'
import about from '../Image/company-about.png'

function Aboutus() {
    return (
        <>
            <section className="breadcrumb-area banner-1" data-background="images/banner/9.jpg">
                <div className="text-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 v-center">
                                <div className="bread-inner">
                                    <div className="bread-menu">
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><a href="#">About Us</a></li>
                                        </ul>
                                    </div>
                                    <div className="bread-title">
                                        <h2>About Us</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="about-agency pad-tb block-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 v-center">
                            <div className="about-image">
                                <img src={about} alt="about us" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="common-heading text-l ">
                                <span>About Us</span>
                                <h2>About N D Techland</h2>
                                <p style={{ textAlign: "justify" }}>N D Techland Pvt. Ltd. is a trusted IT solutions and e-Governance technology company delivering innovative digital solutions to government organizations, enterprises, and institutions across India. The company specializes in designing and implementing scalable, secure, and user-friendly technology platforms that enhance efficiency, transparency, and service delivery.</p>
                                <p style={{ textAlign: "justify" }}>With strong expertise in digital transformation, N D Techland provides end-to-end services including consulting, system design, software development, deployment, and long-term technical support. The organization is committed to leveraging modern technologies such as GIS, cloud computing, enterprise automation, and mobile applications to build future-ready solutions.</p>
                                 <p style={{ textAlign: "justify" }}>Driven by innovation, technical excellence, and a client-centric approach, N D Techland aims to empower organizations with reliable digital systems that support smart governance and efficient business operations.</p>
                            </div>
                            <div className="row in-stats small about-statistics">
                                <div className="col-lg-4 col-sm-4">
                                    <div className="statistics">
                                        <div className="statnumb counter-number">
                                            <span className="counter">450</span>
                                            <p>Happy Clients</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-4">
                                    <div className="statistics">
                                        <div className="statnumb">
                                            <span className="counter">95</span><span>k</span>
                                            <p>Hours Worked</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-4">
                                    <div className="statistics mb0">
                                        <div className="statnumb counter-number">
                                            <span className="counter">850</span>
                                            <p>Projects Done</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="why-choose pad-tb">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="common-heading">
                                <span>We Are Awesome</span>
                                <h2 className="mb30">Why Choose Us</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row upset">
                        {[
                            {
                                icon: "/images/icons/research.svg",
                                title: "Research and Analysis",
                                text: "Our research and development team always finds what's best for a website.",
                            },
                            {
                                icon: "/images/icons/chat.svg",
                                title: "Negotiation and Power",
                                text: "Negotiation is not a priority if you got powerful and best quality products.",
                            },
                            {
                                icon: "/images/icons/monitor.svg",
                                title: "Creative and Innovative Solutions",
                                text: "We always provide the most innovative and creative ideas to our clients.",
                            },
                            {
                                icon: "/images/icons/trasparency.svg",
                                title: "Transparency and Ease of Work",
                                text: "From start to end of the project, everything is transparent and every step is in knowledge of our clients.",
                            },
                            {
                                icon: "/images/icons/support.png",
                                title: "24/7 Support",
                                text: "We provide round-the-clock support to ensure smooth operations for our clients.",
                            },
                            {
                                icon: "/images/icons/money-growth.svg",
                                title: "Focus on Growth",
                                text: "We aim to deliver solutions that ensure long-term growth and sustainability.",
                            },
                        ].map((item, index) => (
                            <div key={index} className="col-lg-4 col-sm-6 mt30 d-flex">
                                <div className="s-block up-hor flex-fill">
                                    <div className="s-card-icon">
                                        <img src={item.icon} alt={item.title} className="img-fluid" />
                                    </div>
                                    <h4>{item.title}</h4>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Aboutus